import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (23 / 24);
  const localHeight = size * (23 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 23 23">
      <g transform="translate(-3521 -7065)">
        <path
          d="M446.1,1471.939a11.5,11.5,0,1,1,11.5,11.5A11.513,11.513,0,0,1,446.1,1471.939Zm1.586,0a9.914,9.914,0,1,0,9.914-9.914A9.925,9.925,0,0,0,447.688,1471.939Zm9.121,5.618v-4.825h-4.825a.793.793,0,0,1,0-1.586h4.825v-4.825a.793.793,0,1,1,1.586,0v4.825h4.825a.793.793,0,0,1,0,1.586h-4.825v4.825a.793.793,0,0,1-1.586,0Z"
          transform="translate(3074.898 5604.561)"
          fill={localColor}
        />
      </g>
    </svg>
  );
};

export default Index;
